module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', {
    staticClass: "kt-datatable__body"
  }, _vm._l((_vm.saldo), function(data) {
    return _c('span', {
      key: data.id
    }, [_c('tr', {
      staticClass: "kt-datatable__row"
    }, [_c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v("EUP-" + _vm._s(data.id))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', [_vm._v(_vm._s(data.attributes.titleOperation) + " "), _c('br'), _c('br'), _vm._v("\n                " + _vm._s(data.attributes.descriptionOperation) + " "), _c('br'), _c('br'), _vm._v("\n\n                " + _vm._s(data.attributes.purchaseorder_id !== null ?
      "N° orden #" + data.attributes.purchaseorder_id :
      "") + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.attributes.pasarela))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(" " + _vm._s(data.attributes.date) + " "), _c('br')])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(data.attributes.amount))])])])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getPedidos
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-152c0f19"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-user/SaldoComponent.vue
// module id = 1853
// module chunks = 1